import { TicketServiceType as r } from "./ticketServiceType.js";
var a = /* @__PURE__ */ ((e) => (e[e.TAKEAWAY = 1] = "TAKEAWAY", e[e.DELIVERY = 2] = "DELIVERY", e[e.DINE_IN = 3] = "DINE_IN", e))(a || {});
const n = {
  1: "takeaway",
  2: "delivery",
  3: "dine_in"
}, c = {
  takeaway: 1,
  delivery: 2,
  dine_in: 3
  /* DINE_IN */
}, i = {
  1: "takeaway",
  2: "delivery",
  3: "dinein"
};
function E(e) {
  switch (e) {
    case 3:
      return r.DINEIN;
    case 2:
      return r.DELIVERY;
    case 1:
      return r.TAKEAWAY;
    default:
      throw new Error("Unreachable");
  }
}
function s(e) {
  switch (e) {
    case r.DINEIN:
      return 3;
    case r.DELIVERY:
      return 2;
    case r.TAKEAWAY:
      return 1;
    default:
      throw new Error("Unreachable");
  }
}
export {
  n as ServiceMapNames,
  i as ServiceMapNamesBackend,
  c as ServiceMapTypes,
  a as ServiceType,
  E as serviceTypeToTicket,
  s as ticketToService
};
//# sourceMappingURL=serviceType.js.map
